<template>
  <main>
    <error-notification />
    <header role="banner" class="container-banner">
      <img class="logo" src="~@imagesBrand/logo.svg">
      <router-link v-t to="/signup">Create Account</router-link>
    </header>
    <section class="container-small">
      <vue-form :state="formstate" class="form notranslate" @submit.prevent="login">
        <h3 v-t>CI Direct Investing for Advisors</h3>
        <h4 v-t>Sign In</h4>

        <validate class="field">
          <label v-t for="email">Email</label>
          <input id="email" v-model="model.email" type="text" name="email" required>
          <field-messages name="email" class="error-message">
            <template slot="required">
              <small v-if="formstate.$touched || formstate.$submitted" v-t class="error">Required</small>
            </template>
          </field-messages>
        </validate>

        <validate class="field">
          <label v-t for="password">Password</label>
          <input-password v-model="model.password" class="input" name="password" required />
          <field-messages name="password" class="error-message">
            <template slot="required">
              <small v-if="formstate.$touched || formstate.$submitted" v-t class="error">Required</small>
            </template>
          </field-messages>
        </validate>

        <button v-if="!loading" v-t type="submit" class="full">Sign In</button>
        <div v-else class="loader">
          <loading-spinner size="1rem" />
          <span v-t>Signing In…</span>
        </div>
        <div v-if="errorMessage" class="error-message">
          <p>
            <span>{{ errorMessage }} </span>
            <span v-t>Please </span>
            &nbsp;
            <button v-t class="neg" @click="showIntercom()">contact us</button>
            &nbsp;
            <span v-t> if you require assistance.</span>
          </p>
        </div>
        <p class="pw-reset"><a v-t :href="pwReset">Forgot Password?</a></p>
      </vue-form>
    </section>
  </main>
</template>

<script>
import { http } from '@/lib/api/rest';
import { auth0Login } from '@/lib/auth';
import { intercom } from '@/lib/analytics';
import { getAndRemoveItem } from '@/lib/utils/storage';
import getBrandConfig from '@/lib/utils/get_brand_config';
import { apiUrl } from '@/lib/utils/constants';
import { inputPassword, loadingSpinner, errorNotification } from '@/components/layout';
import errorStore from '@/store/error';

const brandConfig = getBrandConfig();
const _ = {
  auth: brandConfig.auth,
  auth0Login,
  getAndRemoveItem,
  intercom,
  errorStore,
  http,
};

export default {
  _,
  components: { inputPassword, loadingSpinner, errorNotification },
  data() {
    return {
      formstate: {},
      errorMessage: '',
      loading: false,
      model: {
        email: '',
        password: '',
      },
    };
  },
  computed: {
    pwReset() { return `${apiUrl.host}/reset-password`; },
  },
  async beforeRouteEnter(to, from, next) {
    if (_.auth === 'auth0') {
      _.auth0Login();
    } else { next(); }
  },
  methods: {
    async login() {
      if (this.formstate.$invalid || this.loading) return;
      this.loading = true;
      this.errorMessage = '';
      try {
        await _.http.post('sessions/login', this.model);
        const returnPath = _.getAndRemoveItem('returnPath');
        this.$router.push(returnPath || '/app/clients');
      } catch (exception) {
        this.loading = false;
        if (exception.response && exception.response.status === 403) {
          this.errorMessage = this.$t('Invalid e-mail or password.');
        } else if (exception.response && exception.response.status === 400) {
          this.errorMessage = this.$t('Account not registered to an Advisor');
        } else if (exception.response && exception.response.status === 499) {
          window.location = `${apiUrl.host}/two-factor?method=${exception.response.data.tfaMethod}&partner_channel=${brandConfig.brand}`;
        } else {
          _.errorStore.addError();
        }
      }
    },
    showIntercom() {
      _.intercom('show');
    },
  },
};
</script>
<style lang="scss" scoped>
  main {
    display: flex;
    flex-direction: column;
  }
  header[role="banner"]  {
    background: $white;
    width: 100%;
    z-index: 5;
    border-bottom: 1px solid $pearl-300;
    height: 3.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1.5rem;
    @media #{$screen-width-medium} {
      padding: 0.5rem 3rem;
    }
  }
  .logo {
    height: 2.375rem;
    max-width: 10rem;
  }
  section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1 1 100%;
  }
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    span { margin-left: 0.25rem; }
  }
  .pw-reset { margin: 1rem 0; }
</style>
